import Site from './Site';
import SheetPage from './pages/SheetPage';
import { PAGES, SECTIONS } from './config';

// The whole site is one page, but a few old addresses still matter:
//   /EPK, /FYC, /GPJ, /Trio  -> stand-alone sheet pages
//   /Bio, /Calendar, ...     -> scroll to the matching section
const legacy = {};
SECTIONS.forEach((s) => (s.legacy || []).forEach((path) => { legacy[path] = s.id; }));

export default function App() {
  const segment = window.location.pathname.replace(/^\/+|\/+$/g, '').split('/')[0].toLowerCase();
  if (PAGES[segment]) return <SheetPage page={PAGES[segment]} />;
  return <Site initialTarget={legacy[segment]} />;
}
